import { render, staticRenderFns } from "./CourseNewProductForm.vue?vue&type=template&id=552047f5&scoped=true"
import script from "./CourseNewProductForm.vue?vue&type=script&lang=js"
export * from "./CourseNewProductForm.vue?vue&type=script&lang=js"
import style0 from "./CourseNewProductForm.vue?vue&type=style&index=0&id=552047f5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552047f5",
  null
  
)

export default component.exports